import React from 'react';
import PropTypes from 'prop-types';
import {
  Container,
  Row
} from 'reactstrap';
import Card from '../../shared/Card';
import styles from './styles.scss';

class StateSpecificNotes extends React.Component {
  constructor(props) {
    super(props);
  }

  static get propTypes() {
    return {
      value: PropTypes.string
    }
  }

  render() {
    const {
      value
    } = this.props;

    return (
      <Card header='State Specific Notes'>
        <Container>
          <Row className='mb-3'>
            <label className={`d-block ${styles.label}`}>{value || '-'}</label>
          </Row>
        </Container>
      </Card>
    );
  }
}

export default StateSpecificNotes;



// WEBPACK FOOTER //
// src/components/shared/StateSpecificNotes/index.jsx